export default __webpack_public_path__ + "static/media/FG_50.c681a87d.jpg";